module.exports = __webpack_public_path__ + "media/images/line_chart_sample-372692d3c64db2ec5a5cc436c31f3d72.png";